import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular/main';

import { AppComponent, LogoutDialogComponent } from './app.component';
import { OkDialogComponent } from './dialog/ok-dialog.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { QuarantineComponent } from './quarantine/quarantine.component';
import { QuarantineOperationButtonRendererComponent } from './quarantine/quarantine-operation-cell.component';
import { HistoryComponent } from './history/history.component';
import { HistoryUndoButtonRendererComponent } from './history/history-undo-cell.component';
import { MatchComponent} from './match/match.component';
import { ElasticDialogComponent } from './match/elastic-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule} from '@swimlane/ngx-charts';
import { HomeService} from './home/home.service';
import { HttpClientModule} from '@angular/common/http';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpClientModule } from '@ngx-progressbar/http-client';
import { FormsModule } from '@angular/forms';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
} from '@angular/material';
import {DecimalPipe, DatePipe} from '@angular/common';
import {CounterDirective} from './counter.directive';
import {MatchService} from './match/match.service';
import {QuarantineService} from './quarantine/quarantine.service';
import {HistoryService} from './history/history.service';
import {AuthService} from './guard/auth.service';

import {IsrcPipe} from './pipes/isrc.pipe';

@NgModule({
  exports: [

    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
  ],
  declarations: [
    AppComponent,
    LogoutDialogComponent,
    OkDialogComponent,
    LoginComponent,
    HomeComponent,
    QuarantineComponent,
    HistoryComponent,
    MatchComponent,
    CounterDirective,
    ElasticDialogComponent,
    QuarantineOperationButtonRendererComponent,
    HistoryUndoButtonRendererComponent,

    IsrcPipe
  ],
  imports: [
    BrowserModule, NgbModule.forRoot(), AppRoutingModule, BrowserAnimationsModule,
    NgProgressModule.forRoot(), NgProgressHttpClientModule,
    AgGridModule.withComponents([
      QuarantineOperationButtonRendererComponent,
      HistoryUndoButtonRendererComponent
    ]),
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    HttpClientModule,
    NgxChartsModule,
    FormsModule,
  ],
  providers: [HomeService, HttpClientModule, MatchService, QuarantineService, HistoryService, AuthService, DecimalPipe, DatePipe, IsrcPipe],
  bootstrap: [AppComponent],
  entryComponents : [ElasticDialogComponent, OkDialogComponent, LogoutDialogComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts